/* global G */
import { curry } from 'lib/util'
import session from 'app/_shared/session'

/**
 * @typedef {'view'|'search'} Action
 */

/**
 * @typedef {'equipment'|'article'|'documentation'} ObjectType
 */

/**
 * @typedef {Object} LogPayload
 * @property {Action} action            the action that caused this logging request
 * @property {string} objectID          the id of the object to be logged
 * @property {ObjectType} objectType    the type of the object to be logged
 * @property {string} [term]            an optional search term that lead to here
 * @property {string} [country]         an optional country of the user
 * @property {string} langClient        the current language of the client
 * @property {string} [emailSuffix]     an optional email suffix of the person
 */

/**
 * Get Log Payload Event Handler
 *
 * Parses the data contained in event, builds a payload and returns it.
 *
 * @param {Gaia.AppModule.Spec} module    current module
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Gaia.PlatformEvent} event      the event object
 * @returns {LogPayload}
 */
const getPayload = (module, component, event) => {
  const { data = event?.detail || {} } = event?.detail || event || {}

  const currentLanguage = module[G.ADAPTER][G.SESSION][G.STATE][G.LANGUAGE]
  const person = session(module).person.ref({ wrap: false })
  const user = session(module).user.ref({ wrap: false })

  const ref = module[G.MODEL][G.STATE][G.REF]

  const {
    documentationId,
    term,
    type = 'documentation',
    key = ref,
    value: { documentationId: attachmentDocumentationId } = {},
  } = data?.value || data || {}

  const action = term ? 'search' : 'view'
  const email = person.value.contactChannels.find(c => c.type === 'email')?.value
  const country = user?.value?.custom?.user?.countryIso2

  return {
    action,
    objectID: documentationId || attachmentDocumentationId || key,
    objectType: type === 'docChunk' ? 'documentation' : type,
    term,

    country,
    langClient: currentLanguage,
    emailSuffix: email && email.includes('@')
      ? email.split('@').pop()
      : null,
  }
}

export default curry(getPayload)
